import { Component, OnInit, Input } from '@angular/core';
import { ItemObject } from 'src/app/models/orders/item/item-object.model';
import { Product } from 'src/app/models/interface/product/product';

@Component({
  selector: 'app-product-depth-level',
  templateUrl: './product-depth-level.component.html',
  styleUrls: ['./product-depth-level.component.scss']
})
export class ProductDepthLevelComponent implements OnInit {

  @Input() item: Product;
  @Input() params: any;
  @Input() isps: any[];

  constructor() { }

  ngOnInit() {
  }

}
